import React from "react";
import cx from "classnames";

type Option = {
  id: string;
  name: string;
};

type Props = {
  placeholder: string;
  options: Option[];
  placeholderStyle?: any;
  label?: string;
  isHelp?: boolean;
  helpText?: string;
} & React.SelectHTMLAttributes<HTMLSelectElement>;

const SelectInputAuth: React.FC<Props> = ({
  placeholder,
  placeholderStyle,
  label,
  helpText,
  isHelp,
  className,
  options,
  value,
  onChange,
  name,
}): JSX.Element => {
  return (
    <div className={cx("flex flex-col min-w-0", className)}>
      {label && (
        <span
          className="font-sora text-sm"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#A5A5A5",
          }}
        >
          {label}
        </span>
      )}
      <div className="flex flex-row">
        <select
          className={cx(
            "w-full h-14 text-sm font-sora",
            isHelp ? "border-bt-red my-1" : "my-2",
            placeholderStyle
          )}
          onChange={onChange}
          value={value || "0"}
          defaultValue={value || "0"}
          name={name}
          style={{
            background: "#FFFFFF",
            border: isHelp ? "2px solid #FD5B28" : "0.5px solid #8E8E8E",
            borderRadius: "4px",
            color: "#7A808C",
          }}
        >
          <option key={"0"} value={"0"} disabled>
            {placeholder || ""}
          </option>
          {options.map((option, idx) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
      {isHelp && helpText && (
        <div className="flex flex-row">
          <span className="font-nunito mt-1 text-xs text-bt-red">
            {helpText}
          </span>
        </div>
      )}
    </div>
  );
};

export default SelectInputAuth;
